import { BrowserRouter } from "react-router-dom";

import ParentRouter from "./pages/parentRouter";
import TeacherEvaluationRouter from "./pages/teacherEvaluationRouter";
import UserRouter from "./pages/userRouter";

import { Authenticator, AuthenticatedArea } from "components";
import { RouterCommitBreadcrumb } from "components/RouterCommitBreadcrumb/RouterCommitBreadcrumb";
import InvalidTokenModal from "components/Modal/InvalidTokenModal/InvalidTokenModal";
import SessionConflictModal from "components/Modal/SessionConflictModal/SessionConflictModal";
import { NotAuthenticated } from "features/NotAuthenticated";
import { DarkModeProvider } from "context/DarkModeContext";

import { useAppSelector } from "store/hooks";
import { selectToken, selectParentToken, selectTeacherEvaluationToken } from "store/slices/token";

import "./App.scss";
import "./Print.scss";

function App() {
  const token = useAppSelector(selectToken);
  const parentToken = useAppSelector(selectParentToken);
  const teacherEvaluationToken = useAppSelector(selectTeacherEvaluationToken);

  return (
    <DarkModeProvider>
      <BrowserRouter>
        <RouterCommitBreadcrumb />
        <Authenticator>
          {typeof token === "string" && token.length > 0 ? (
            <>
              <AuthenticatedArea>
                <>
                  <UserRouter />
                  <SessionConflictModal />
                </>
              </AuthenticatedArea>
              {/* AIDEV-NOTE: Vedle AuthenticatedArea, ne uvnitř — ta při chybě načtení uživatele
                  (první selhané dotazy po přihlášení jinde) children nevykreslí. [TD-460] */}
              <InvalidTokenModal />
            </>
          ) : typeof parentToken === "string" && parentToken.length > 0 ? (
            <ParentRouter />
          ) : typeof teacherEvaluationToken === "string" && teacherEvaluationToken.length > 0 ? (
            <TeacherEvaluationRouter />
          ) : (
            <NotAuthenticated />
          )}
        </Authenticator>
      </BrowserRouter>
    </DarkModeProvider>
  );
}

export default App;
